import { useEffect, useState } from 'react';

export default function Spacing({
  size,
  desktopSize = size,
  screenMinWidth = 768,
}: {
  size: number;
  desktopSize?: number;
  screenMinWidth?: number;
}) {
  const [height, setHeight] = useState(size);

  const setSpacingHeight = () => {
    const mediaMatch = window?.matchMedia(`(min-width: ${screenMinWidth}px)`);

    setHeight(mediaMatch.matches ? desktopSize : size);
  };

  useEffect(() => {
    setSpacingHeight();
    window.addEventListener('resize', setSpacingHeight);

    return () => window.removeEventListener('resize', setSpacingHeight);
  }, []);

  return <div style={{ height: `${height}px` }} />;
}
